import withRegistrationCountDown from '../../common/CountDown/withRegistrationCountDown';
import { CardInfoBlock } from '../../common/Card';

export default withRegistrationCountDown(CardInfoBlock);
